import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs';
import { ToastService } from 'src/app/shared-new/services/toast.service';
import { ChangePasswordModel } from '../../models/recovery/change-password.model';
import { User } from '../../models/vet-users/user.model';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { RecoveryFacade } from '../../shared-new/store/recovery/recovery.facade';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss'],
})
export class RecoverPasswordComponent
  extends BaseUnsubscribeComponent
  implements OnInit
{
  public encryptedId: string;
  public isLoader: boolean;
  public changePasswordForm: FormGroup;
  changePassword$ = this.recoveryFacade.changePassword$;
  userByRecoveryEncryptedId$ = this.recoveryFacade.userByRecoveryEncryptedId$;
  public model: ChangePasswordModel = new ChangePasswordModel();
  public user: User;
  constructor(
    private recoveryFacade: RecoveryFacade,
    private route: ActivatedRoute,
    private router: Router,
    private toastService: ToastService
  ) {
    super();
  }

  ngOnInit(): void {
    this.changePasswordForm = ChangePasswordModel.asFormGroup(this.model);

    this.encryptedId = String(this.route.snapshot.paramMap.get('id'));
    this.isLoader = true;
    this.recoveryFacade.getUserByRecoveryEncryptedId(this.encryptedId);
    this.userByRecoveryEncryptedId$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (user) => {
          this.user = user;
          this.isLoader = false;
        },
        (error) => {
          console.log(error);
        }
      );
  }
  GoBackToLogin() {
    this.router.navigateByUrl('/login');
  }
  submitForm(form: any): void {
    if (this.user.userId) {
      this.model.password = form.password;
      this.model.confirm = form.confirm;
      this.model.recoveryKey = this.encryptedId;
      this.recoveryFacade.changePassword(this.model);
      this.changePassword$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((response) => {
          if (response) {
            this.toastService.success('Password has been changed successfully');
            setTimeout(() => {
              this.router.navigateByUrl('/login');
            }, 1000);
          }
        });
    }
  }
}
